// ============================================
// Utility / helper functions
// ============================================

/**
 * Format a runtime in minutes to "Xh Ym"
 */
export function formatRuntime(minutes) {
    const h = Math.floor(minutes / 60);
    const m = minutes % 60;
    if (h === 0) return `${m}m`;
    return m === 0 ? `${h}h` : `${h}h ${m}m`;
}

/**
 * Format a number with K/M suffix
 */
export function formatCount(n) {
    if (n >= 1_000_000) return `${(n / 1_000_000).toFixed(1)}M`;
    if (n >= 1_000) return `${(n / 1_000).toFixed(1)}K`;
    return String(n);
}

/**
 * Clamp a value between min and max
 */
export function clamp(value, min, max) {
    return Math.min(Math.max(value, min), max);
}

/**
 * Capitalize first letter of a string
 */
export function capitalize(str) {
    if (!str) return '';
    return str.charAt(0).toUpperCase() + str.slice(1);
}

/**
 * Generate a share URL for a challenge
 */
export function getChallengeUrl(movieSlug) {
    return `${window.location.origin}/challenge/${movieSlug}`;
}